import { render, staticRenderFns } from "./cartempcarfeerule.vue?vue&type=template&id=bcb880fe&"
import script from "./cartempcarfeerule.vue?vue&type=script&lang=js&"
export * from "./cartempcarfeerule.vue?vue&type=script&lang=js&"
import style0 from "./cartempcarfeerule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports